import React from "react";
import "./ServicesHeader.css";

const ServicesHeader = () => {
  return (
    <section className="ServicesHeader-container">
      <div className="ServicesHeader-overlay">
        <div className="container" style={{ textAlign: "center" }}>
          <h1 className="ServicesHeader-title">Our Services</h1>
          <div className="ServicesHeader-breadcrumb">
            <button className="btn btn-primary">Home - Our Services</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesHeader;
